import { useEffect } from "react";
import { ObservationQuestion } from "src/components";
import {
	filterQuestionsUpToBranching,
	handleBranchedQuestionAnswered
} from "src/features/observations/BranchedQuestions/utils";

export type ObservationQuestionListProps = {
	questions: ObservationQuestion[];

	visibleQuestions: ObservationQuestion[];

	onVisibleQuestionsChange: (questions: ObservationQuestion[]) => void;

	observationType: IObservationType;
};

const ObservationQuestionList = ({
	questions,
	visibleQuestions,
	onVisibleQuestionsChange,
	observationType
}: ObservationQuestionListProps) => {
	useEffect(() => {
		const filteredQuestions = filterQuestionsUpToBranching(questions);
		onVisibleQuestionsChange(filteredQuestions);
	}, []);

	const onAnswerChange = (question: ObservationQuestion) => {
		const updatedQuestions = handleBranchedQuestionAnswered(
			question,
			questions,
			visibleQuestions
		);

		onVisibleQuestionsChange(updatedQuestions);
	};

	return (
		<div>
			<div className="flex flex-col gap-6">
				{visibleQuestions
					.sort((question1, question2) => question1.order - question2.order)
					.map((question) => (
						<div className="w-full" key={question.uuid}>
							<ObservationQuestion
								observationType={observationType}
								onAnswerChange={onAnswerChange}
								{...question}
							/>
						</div>
					))}
			</div>
		</div>
	);
};

export default ObservationQuestionList;
